import img1 from "../../assets/Images/Reports/Waiter-Reports.png"

export default function WaitersReport() {
    return (
        <section id="waiters-report" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    4. Waiters Report
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    The Waiters Report provides a date-wise breakdown of service staff
                    deployed for events, helping management plan manpower and control
                    staffing costs.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        This report is primarily used by operations managers and supervisors
                        to review waiter allocation per event, ensure adequate staffing,
                        and maintain consistency in service quality.
                    </p>
                </section>
            </section>


            {/* FILTER OPTIONS */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Date & Period Filters
                    </h3>
                    <p className="text-slate-600 mb-3">
                        The Waiters Report supports two filtering methods to suit different
                        reporting needs.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Select Month and Year for monthly summaries</li>
                        <li>Use Start Date and End Date for custom periods</li>
                        <li>Only one filter mode is applied at a time</li>
                    </ul>
                </div>
            </section>

            {/* TABLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">
                    Waiters Deployment Table
                </h3>

                <p className="text-slate-600 mb-4">
                    The table displays waiter deployment details for each event date
                    matching the selected filter.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Event Date and Booking Number</li>
                    <li>Total persons for the event</li>
                    <li>Event slot and portion (hall)</li>
                    <li>Assigned Head Waiter</li>
                    <li>Total Waiters, Darban, and Valet staff</li>
                </ul>

                <div className="rounded-lg p-4 mt-4">
                   <img src={img1} alt="" />
                </div>
            </section>

            {/* TOTALS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Totals & Summary
                </h3>

                <p className="text-slate-600">
                    At the bottom of the table, EventFlow calculates totals for key
                    staffing categories, allowing management to quickly assess
                    manpower usage across the selected period.
                </p>
            </section>

            {/* SEARCH */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Search Functionality
                </h3>

                <p className="text-slate-600 mb-3">
                    The search box allows users to filter records instantly.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Search by booking number</li>
                    <li>Search by date or portion</li>
                    <li>Helpful for reviewing specific events</li>
                </ul>
            </section>

            {/* EXPORT */}
            <section className="bg-[#C9A24E]/10 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Exporting Waiters Report
                </h3>

                <p className="text-slate-600 mb-3">
                    The Waiters Report can be exported for staffing analysis and record keeping.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Export report to Excel format</li>
                    <li>Download printable PDF version</li>
                    <li>Useful for payroll planning and audits</li>
                </ul>
            </section>

        </section>
    );
}
